module.exports = __webpack_public_path__ + "static/img/recent.c5e895d8.svg";